import React from 'react';
import { useSelector } from 'react-redux';
import { ImageAnnotate } from './workspace/imageAnnotate';
import { TextEditor } from './workspace/textEditor';
const ControllerController = {
    'text-editor': TextEditor,
    'image-annotate': ImageAnnotate,
};
export function Controller() {
    const activeController = useSelector((state) => state.editor.activeController);
    const ControllerComponent = ControllerController[activeController];
    if (!ControllerComponent) {
        return null;
    }
    return React.createElement(ControllerComponent, null);
}
